jQuery(function(){

    var broshuresList = $(".broshures-list");
    var broshuresOrderForm = $(".order-broshures");
    if (broshuresList.length == 0)
        return;

    $(window).on("load", function () {
        equalHeight($(".broshures-list .tabgallery .tabs-content .tabs-panel .list .broshure"), true);
    });

    $(window).on("orientationchange resize", function () {
        equalHeight($(".broshures-list .tabgallery .tabs-content .tabs-panel .list .broshure"), true);
    });

    $('.broshures-list ul.tabs').on('change.zf.tabs', function (event, tab) {
        equalHeight($(".broshures-list .tabgallery .tabs-content .tabs-panel .list .broshure"), true);
    });

    var container = $(".dce-werbevarianten");
    if(container.length == 0)
        return;
    var cid = container.data("cid");
    var pid = container.data("pid");
    if(!cid || !pid)
        return;

    var domainReloadParameters = window.pixelpoint.utilities.getSysPageUrl();
    var endpoint = '';
    if(domainReloadParameters.useAjaxRenderPageId){
        endpoint = `${domainReloadParameters.baseUrl}?id=${domainReloadParameters.ajaxRenderPageId}&cid=${cid}&pid=${pid}&no_cache=1`;
    }
    else{
        endpoint = `${domainReloadParameters.baseUrl}?cid=${cid}&pid=${pid}&no_cache=1`;
    }
    $.get(endpoint).done(response => {
        var box = $(response).find('.broshure-box');
        if(box.length > 0){
            var broshureBox = container.find(".broshure-box");
            broshureBox.html(box.html());
            window.ppComponents.sliders.sliderBox.init(broshureBox);
        }
    });
});